export const useIsUserInRole = () => {
    const userInfo = useStateUserInfo();

    return function (role: Role) {
        return userInfo.value.Roles.includes(role);
    };
};
